var React = require('react');

function Pl (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"10","fill":"#fff","key":0}),React.createElement("rect",{"width":"16","height":"5","fill":"#dc143c","y":"5","key":1})]);
}

Pl.defaultProps = {"width":"1280","height":"800","id":"Flag of Poland","viewBox":"0 0 16 10"};

module.exports = Pl;

Pl.default = Pl;
